import { SocialService } from '../../../types/SocialService';
import { TrackingEvent } from '../types';

// Please update `./README.md` when changing the tracking configuration!

export const clickedShareInContent = (url: string, service: SocialService): TrackingEvent[] => [{
    category: 'website usage',
    action: 'click - share in content',
    name: `${service} - ${url}`,
}];
